import React, { useEffect, useRef, useState } from "react";
import Input from "../../../../components/common/inputs/Input";
import Select from "../../../../components/common/inputs/Select";
import { Form, Formik } from "formik";
import RolesSelect from "../../../../components/common/inputs/RolesSelect";
import Button from "../../../../components/common/button/Button";
import { postApi } from "../../../../services/api/globalApi";
import { successMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import { useSelector } from "react-redux";
import { utilsState } from "../../../../sotre/redux/features/utilsSlice";
import {
  linkCodeExteraDiscountValidation,
  roleExteraDiscountValidation,
} from "../../../../utils/validations/discount/exteraDiscountValidation";

function ExtraDiscount({ data }) {
  const { utils } = useSelector(utilsState);

  const [extera, setExtera] = useState([]);

  useEffect(() => {
    if (data?.length) {
      setExtera(data);
    }
  }, [data]);

  const roleRef = useRef();

  const [discountType, setDiscountType] = useState("role");
  const [roles, setRoles] = useState([]);
  console.log(data);
  const formHandler = async (values, { resetForm }) => {
    values["isActive"] = values.isActive == "true" ? true : false;
    if (discountType == "role") {
      delete values["linkCode"];
      const data = {
        ...values,
        pecent: Number(values.percent),
        roles,
        type: discountType,
      };
      setExtera((prev) => [...prev, data]);
      roleRef.current.afterSubmit();
    } else if (discountType == "linkCode") {
      const data = {
        ...values,
        pecent: Number(values.percent),
        type: discountType,
      };
      setExtera((prevState) => [...prevState, data]);
    }
    resetForm();
  };

  const handleRoles = (data) => {
    setRoles(data);
  };

  console.log(extera);

  const handle = async () => {
    const path = "admin/discounts";
    const body = {
      extraDiscount: extera,
    };
    try {
      const data = await postApi({ path, body });
      console.log(data);
      successMessage("تخفیف با موفقیت بروزرسانی شد.");
    } catch (error) {
      console.log(error);
    }
  };

  const deleteExteraDiscount = (index) => {
    let newExtra = [...extera];
    newExtra.splice(index, 1);
    setExtera(newExtra);
  };

  return (
    <div className="w-full py-4 px-4 border-r border-l">
      <Formik
        enableReinitialize
        initialValues={{
          percent: "",
          linkCode: "",
          isActive: true,
        }}
        validationSchema={
          discountType == "role"
            ? roleExteraDiscountValidation
            : linkCodeExteraDiscountValidation
        }
        onSubmit={formHandler}
      >
        <Form>
          <div className="grid gap-6 mb-4 md:grid-cols-2">
            <Input name="percent" placeholder="درصد" label="درصد" type="text" />
            <Select name="isActive" placeholder="فعال باشه؟" label="فعال باشه؟">
              <option value={"true"}>بله</option>
              <option value={"false"}>خیر</option>
            </Select>
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                نوع تخفیف
              </label>
              <select
                value={discountType}
                onChange={(e) => setDiscountType(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              >
                <option value={"linkCode"}>linkCode</option>
                <option value={"role"}>role</option>
              </select>
            </div>
            {discountType == "linkCode" && (
              <Input
                name="linkCode"
                placeholder="کد ارجاع"
                label="کد ارجاع"
                type="text"
              />
            )}
            {discountType == "role" && (
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  انتخاب نقش
                </label>
                <RolesSelect ref={roleRef} onChange={handleRoles} />
              </div>
            )}
          </div>
          <div className="mb-3">
            <Button color="primary" text={"ثبت"} />
          </div>
        </Form>
      </Formik>

      <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
        {extera.length ? (
          <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3">
                  درصد تخفیف
                </th>
                <th scope="col" class="px-6 py-3">
                  فعال باشه
                </th>
                <th scope="col" class="px-6 py-3">
                  نوع
                </th>
                <th scope="col" class="px-6 py-3">
                  لینک ارجاع
                </th>
                <th scope="col" class="px-6 py-3">
                  رول ها
                </th>
                <th scope="col" class="px-6 py-3">
                  عملیات
                </th>
              </tr>
            </thead>
            <tbody>
              {extera.map((item, index) => {
                return (
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {item.percent}
                    </th>
                    <td class="px-6 py-4">{item.isActive ? "بله" : "خیر"}</td>
                    <td class="px-6 py-4">{item.type}</td>
                    <td class="px-6 py-4">{item.linkCode}</td>
                    <td class="px-6 py-4">
                      {item?.roles?.length
                        ? item.roles.map((item) => {
                            return (
                              <span>
                                {utils?.ROLES[item]?.name} {" ,"}
                              </span>
                            );
                          })
                        : null}
                    </td>
                    <td class="px-6 py-4 text-right">
                      {/* <button class="font-medium text-blue-600 dark:text-blue-500 hover:underline">
                        ویرایش
                      </button> */}
                      <button
                        onClick={() => deleteExteraDiscount(index)}
                        class="font-medium text-red-600 dark:text-red-500 hover:underline"
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : null}
      </div>
      <div onClick={handle} className="flex flex-col gap-y-2">
        <div className="mt-6">
          <Button text={"بروزرسانی تخفیف"} color={"success"} />
        </div>
      </div>
    </div>
  );
}

export default ExtraDiscount;
